var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-space"},[_c('IDEEditor',{attrs:{"files":_vm.files},on:{"save":_vm.saveFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }